import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAddBookMutation } from "../features/api/apiSlice";

function AddBook() {
  const [addBook, { isLoading, isSuccess, isError }] = useAddBookMutation();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [author, setAuthor] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [price, setPrice] = useState("");
  const [rating, setRating] = useState("");
  const [featured, setFeatured] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    const payload = { name, author, thumbnail, price, rating, featured };
    addBook(payload);
  }

  useEffect(() => {
    isSuccess && navigate("/");
  }, [isSuccess, navigate]);

  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
          <form className="book-form" onSubmit={handleSubmit}>
            <div className="space-y-2">
              <label for="lws-bookName">Book Name</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-bookName"
                name="name"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label for="lws-author">Author</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-author"
                name="author"
                value={author}
                onChange={(event) => setAuthor(event.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label for="lws-thumbnail">Image Url</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-thumbnail"
                name="thumbnail"
                value={thumbnail}
                onChange={(event) => setThumbnail(event.target.value)}
              />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label for="lws-price">Price</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-price"
                  name="price"
                  value={price}
                  onChange={(event) => setPrice(event.target.value)}
                />
              </div>

              <div className="space-y-2">
                <label for="lws-rating">Rating</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-rating"
                  name="rating"
                  min="1"
                  max="5"
                  value={rating}
                  onChange={(event) => setRating(event.target.value)}
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                id="lws-featured"
                type="checkbox"
                name="featured"
                className="w-4 h-4"
                checked={featured}
                onChange={() => setFeatured(!featured)}
              />
              <label for="lws-featured" className="ml-2 text-sm">
                This is a featured book
              </label>
            </div>
            {isError && <span> Something went wrong...</span>}
            <button
              type="submit"
              className="submit"
              id="lws-submit"
              disabled={isLoading}
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddBook;
